<template lang="pug">
div
  v-card.coach-selector
    v-card-title.pb-0 View as Coach
    v-card-text
      p Select a coach to login as to view and manage reservations.
      v-autocomplete(
        outlined
        hide-details
        :items="coachOptions"
        item-text="email"
        item-value="id"
        v-model="coachIdModel"
        placeholder="Select coach"
        clearable
        :loading="loading"
        aria-label="Select coach"
      )
</template>

<script>
import { mapState } from "vuex"

export default({
  computed: {
    ...mapState({
      coachOptions: state => state.main.coachOptions
    }),
    coachIdModel: {
      get() {
        return this.$store.state.main.coachId
      },
      set(value) {
        this.$store.commit('reset')
        this.$store.commit('setCoachId', value)
        this.$store.dispatch('refresh')
      }
    }
  }
})
</script>